import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { avatarItemsApi } from '../services/catalogServiceAPI/avatarItemsProxy';

// One list for every select on the page (a challenge form shows four).
let prizeItemsPromise = null;
const loadPrizeItems = () => {
    prizeItemsPromise ??= avatarItemsApi.list()
        .then((items) => items.filter((item) => item.unlock === 'reward'))
        .catch(() => { prizeItemsPromise = null; return []; });
    return prizeItemsPromise;
};

/** Picks an avatar item to give as a challenge prize. Works as an antd Form control (value / onChange). */
export function AvatarItemSelect({ value, onChange }) {
    const [items, setItems] = useState([]);

    useEffect(() => {
        let mounted = true;
        loadPrizeItems().then((loaded) => { if (mounted) setItems(loaded); });
        return () => { mounted = false; };
    }, []);

    return (
        <Select
            allowClear
            placeholder="None"
            value={value ?? undefined}
            onChange={(next) => onChange?.(next ?? null)}
            options={items.map((item) => ({ value: item.id, label: item.enabled ? item.name : `${item.name} (disabled)` }))}
            notFoundContent="No items set to &quot;Challenge prize&quot; yet"
            style={{ width: '100%' }}
        />
    );
}
